import { render, staticRenderFns } from "./EditFakeTeam.vue?vue&type=template&id=607973ba&scoped=true"
import script from "./EditFakeTeam.vue?vue&type=script&lang=js"
export * from "./EditFakeTeam.vue?vue&type=script&lang=js"
import style0 from "./EditFakeTeam.vue?vue&type=style&index=0&id=607973ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607973ba",
  null
  
)

export default component.exports